import { WrapSmMarginBottom } from 'App/global-style';
import { Markdown } from 'Components/Markdown';
import React from 'react';
import { Variable } from 'Types/text.types';
import { getAppText } from 'Utils/text';
import { getPhoneNumberVariable } from './callUsMessageHtml.helpers';

interface CallUsMessageHtmlProps {
  customMessage?: string;
  phoneNumber?: Variable;
  inlineCustomMessage?: boolean;
}

export const CallUsMessageHtml = ({
  customMessage,
  phoneNumber,
  inlineCustomMessage = true,
}: CallUsMessageHtmlProps): React.ReactElement => {
  const phoneNumberVariable = getPhoneNumberVariable(phoneNumber);
  const defaultMessage = getAppText('callUsMessage.default.markdown', {
    insert: phoneNumberVariable,
  });

  if (!customMessage) {
    return <Markdown>{defaultMessage}</Markdown>;
  }

  if (inlineCustomMessage) {
    const inlineMessage = `${customMessage} ${defaultMessage}`;
    return <Markdown>{inlineMessage}</Markdown>;
  }

  return (
    <>
      <WrapSmMarginBottom>
        <p>{customMessage}</p>
      </WrapSmMarginBottom>
      <Markdown>{defaultMessage}</Markdown>
    </>
  );
};
